import React from 'react'

import { Checkbox } from '@interco/inter-ui/components/Checkbox'
import { Box } from '@atoms'
import { Contrato } from '@store/refinanciamento/contratos/types'
import { ValorParcela } from '@molecules'

interface ContratoDisponivelProps {
  contrato: Contrato
  contratoIndex: number
  isDisabled: boolean
  isDisabledByParcelas: boolean
  checked: boolean
  onClick: () => void
  onChange: () => void
}

const ContratoDisponivel = ({
  contrato,
  contratoIndex,
  isDisabled,
  isDisabledByParcelas,
  checked,
  onClick,
  onChange,
}: ContratoDisponivelProps & React.HTMLAttributes<HTMLDivElement>) => (
  <Box justify="flex-start" margin="16px 0px" key={contrato.numeroContrato} actived={checked}>
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
      }}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') onClick()
      }}
      onClick={onClick}
    >
      <ValorParcela contrato={contrato} isDisabled={isDisabled} />
      <Checkbox
        reversed
        disabled={isDisabled || isDisabledByParcelas}
        id={`checkbox-contrato-${contrato.numeroContrato}-${contratoIndex}`}
        checked={checked}
        onChange={onChange}
      />
    </div>
  </Box>
)

export default ContratoDisponivel
